import { constants } from '../config';
import { Picture } from '../data/models/product_list_response';
import placeholder from '../assets/placeholder/product_placeholder.png';

export const capitalize = (text: string) => {
  return text.replace(/^\w/, (c) => c.toUpperCase());
};

export const formatAmount = (amount: any) => {
  return Intl.NumberFormat('fil-PH', { style: 'currency', currency: 'PHP' }).format(amount);
};

export const getImageUrl = (files: Picture[]) => {
  let url = placeholder;
  if (files != null) {
    if(files.length > 0){
      const file = files[0];
      url = `${constants.API}/media/MediaContent?filePath=${file?.filePath}&fileName=${file?.fileName}`;
    }
  }
  return url;
};

export const toHHMMSS = (seconds_value: string) => {
  const sec_num = parseInt(seconds_value);
  let hours: any = Math.floor(sec_num / 3600);
  let minutes: any = Math.floor((sec_num - hours * 3600) / 60);
  let seconds: any = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  return minutes + ':' + seconds;
};

export const formatDate = (dateTime: Date, separator?: string) => {
  const separator_string = separator ?? ' ';
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const formatted_date =
    dateTime.getDate() + separator_string + months[dateTime.getMonth()] + separator_string + dateTime.getFullYear();
  return formatted_date;
};

export const getStoreSlug = () => {
  const paths = window.location.pathname.split('/');
  if (paths.length > 0) {
    return paths[1];
  }
  return 'invalid-store-slug';
};
